import { loadUserBlogs, saveBlog } from "../../firebaseCalls";

const BLOGS_LOAD_BLOGS_REQUEST = "BLOGS_LOAD_BLOGS_REQUEST";
const BLOGS_LOAD_BLOGS_SUCCESS = "BLOGS_LOAD_BLOGS_SUCCESS";
const BLOGS_LOAD_BLOGS_ERROR = "BLOGS_LOAD_BLOGS_ERROR";

const BLOGS_SAVE_BLOG_REQUEST = "BLOGS_SAVE_BLOG_REQUEST";
const BLOGS_SAVE_BLOG_SUCCESS = "BLOGS_SAVE_BLOG_SUCCESS";
const BLOGS_SAVE_BLOG_ERROR = "BLOGS_SAVE_BLOG_ERROR";

export function loadUserBlogsAction() {
  return async (dispatch, getState) => {
    dispatch({ type: BLOGS_LOAD_BLOGS_REQUEST });
    try {
      const blogs = await loadUserBlogs();
      dispatch({ type: BLOGS_LOAD_BLOGS_SUCCESS, blogs });
    } catch (e) {
      console.log(e);
      dispatch({ type: BLOGS_LOAD_BLOGS_ERROR, error: e });
    }
  };
}

export function saveBlogAction(blog) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BLOGS_SAVE_BLOG_REQUEST });
      const saved = await saveBlog(blog);
      dispatch({ type: BLOGS_SAVE_BLOG_SUCCESS, blog: saved });
    } catch (e) {
      dispatch({ type: BLOGS_SAVE_BLOG_ERROR, error: e });
    }
  };
}

const INIT_STATE = {};

export const blogReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case BLOGS_LOAD_BLOGS_REQUEST:
      return { ...state, loading: true };
    case BLOGS_LOAD_BLOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        blogs: action.blogs
      };
    case BLOGS_LOAD_BLOGS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case BLOGS_SAVE_BLOG_REQUEST:
      return { ...state, saving: true };
    case BLOGS_SAVE_BLOG_SUCCESS:
      return {
        ...state,
        saving: false,
        blog: action.blog,
        blogs: state.blogs
          .filter(b => b.id !== action.blog.id)
          .concat([action.blog])
      };
    case BLOGS_SAVE_BLOG_ERROR:
      return {
        ...state,
        saving: false,
        error: action.error
      };

    default:
      return state;
  }
};

//selectors
export const isLoading = state => state.blogs.loading;
export const isSaving = state => state.blogs.saving;
export const getBlogs = state => state.blogs.blogs;
